/* The Lienzo editor page: its breadcrumb and chips in the topbar, the drawer's panel, its states. */
.srOnly {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

/*
 * The mockup's `.crumbs` with the editable name. From 1024px up it never shrinks below what the
 * name field needs: shrunk further, the field (60px at least) overflowed it and the scope chip was
 * drawn over the field (mockup v3 P4, axe `target-size` at 1280px). Narrower, it shrinks freely so
 * the page never scrolls sideways.
 */
.crumbs {
  display: flex;
  align-items: center;
  gap: 6px;
  min-inline-size: 0;
  font-size: var(--font-size-13);
  white-space: nowrap;
}

@media (min-width: 1024px) {
  .crumbs {
    /* "Lienzo", the separator and the name field's own 60px minimum. */
    min-inline-size: 120px;
  }
}

.crumbLink {
  color: var(--text-subtle);
  text-decoration: none;
}

.crumbLink:hover {
  color: var(--text);
}

.crumbLink:focus-visible {
  border-radius: var(--radius-small);
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.crumbSeparator::before {
  content: "/";
  color: var(--border-strong);
}

/* Scope and tags hide below 1280px, the profile below 1024px (the mockup's `.hide-md`, `.hide-sm`). */
.wideOnly,
.mediumOnly {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
}

@media (max-width: 1279.98px) {
  .wideOnly {
    display: none;
  }
}

@media (max-width: 1023.98px) {
  .mediumOnly {
    display: none;
  }
}

/*
 * Diagrama, Detalles and Nuevo show their words where the topbar has room; narrower, the glyph alone
 * is drawn and the word stays the control's name (owner round 3; the topbar must never scroll
 * sideways). Nuevo joined them with mockup v3 P4's "Más acciones", which left the name field no room.
 */
@media (max-width: 1439.98px) {
  .actionLabel {
    position: absolute;
    inline-size: 1px;
    block-size: 1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
  }
}

.drawerPanel {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding-block-start: var(--space-4);
}

.state {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  background: var(--canvas);
}

/* The drawer's Detalles sections: what the topbar chips show above 1024/1280px, always reachable here. */
.drawerSection {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.drawerHeading {
  margin: 0;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-semibold);
}
